/**
 * The currency staff screens show amounts in.
 *
 * The counter endpoints return integer minor units with no currency, and no endpoint a cashier can call
 * returns the branch currency (the guest app reads it from `POST /guest/tables/resolve`, which needs a QR
 * token). Until the backend supplies it, the currency is deployment configuration: `VITE_BRANCH_CURRENCY`,
 * defaulting to INR (the prototype is INR). It only decides how a server amount is written; no amount is
 * derived from it. Recorded as F3-DEC-01 / F3-LIM-02.
 */
export function parseCurrency(raw: unknown): string {
  const code = typeof raw === 'string' ? raw.trim().toUpperCase() : '';
  return /^[A-Z]{3}$/.test(code) ? code : 'INR';
}

export const COUNTER_CURRENCY = parseCurrency(import.meta.env.VITE_BRANCH_CURRENCY);
